"use client";
// import Link from "next/link";
import { Link } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { Box } from "@radix-ui/themes";
import { TaskItem } from "../task/components/TaskItem";
// import Image from "next/image";
import taskIcon from '../../assets/images/task-icon.png'
import TaskService from "../../services/TaskService";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { getAllTasks, getAllTasksNew, getPendingTasks } from "../../store/reducers/tasks";



const PendingTaskPanel = () => {
  const { pendingTasks, tasks, allTaskdata } = useSelector((state: RootState) => state.tasks);
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(getPendingTasks());
    dispatch(getAllTasksNew());
  }, []);
  console.log("alltasks: ", tasks);
  console.log("pendingtasks: ", pendingTasks);
  console.log("allTaskdata: ", allTaskdata);
  const completedTasks = tasks.filter((task: any) => task.isCompleted === 1);

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="bg-gradient-to-r from-[#4B3F72] to-[#8A7CA8] text-white rounded-xl px-5 py-4 mb-4 flex justify-between text-center">
        <div>
          <div className="text-xs mobile:text-[11px] opacity-80">All Tasks</div>
          <div className="text-lg font-semibold">{allTaskdata?.allTaskCount ?? 0}</div>
        </div>
        <div>
          <div className="text-xs mobile:text-[11px] opacity-80">Pending</div>
          <div className="text-lg font-semibold">{pendingTasks?.length}</div>
        </div>
        <div>
          <div className="text-xs mobile:text-[11px] opacity-80">Completed</div>
          <div className="text-lg font-semibold">{allTaskdata?.isCompletedCount ?? 0}</div>
        </div>
      </div>
      {/* Header */}
      {/* <div className="flex justify-between items-center mb-3">
        <span className="text-[#545455] font-semibold text-sm">
          PENDING TASKS ({pendingTasks.length})
        </span>

        <Link to="/task-list" className="text-[#6C4BAF] text-sm font-medium">
          View All
        </Link>
      </div> */}
      <div className="flex justify-between items-center mb-3">
        <span className="text-[#545455] font-semibold text-sm">
          PENDING TASKS
        </span>
        <Link to="/task-list" className="text-[#6C4BAF] text-sm font-medium">
          View All
        </Link>
      </div>

      {/* List */}
      <div className="flex flex-col gap-3 overflow-y-auto">

        {pendingTasks.length === 0 && (
          <div className="text-sm text-gray-400 text-center mt-10">
            No pending tasks
          </div>
        )}

        {pendingTasks.slice(0, 4).map((task: any, index: number) => (
          <div
            key={task.id}
            className={`rounded-xl p-4 text-sm ${index === 0
              ? "bg-[#F3EAD7]"
              : "bg-white shadow-sm"
              }`}
          >
            <div className="font-medium text-[#545455]">
              {task.title}
            </div>

            <div className="text-xs text-gray-500 mt-1">
              {task.description}
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default PendingTaskPanel;
